export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8890.553c5670.jpg";